export default {
  title: "ΟpenΟps",
  version: "1.1.0"
};
